import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BarraProgressoService {

  private barraProgresso: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public barraProgressoEmitter: Observable<number> = this.barraProgresso.asObservable();

  private nomeProcesso: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public nomeProcessoEmitter: Observable<string> = this.nomeProcesso.asObservable();

  constructor() { }

  atualizaProgresso(passo: number) {
    this.barraProgresso.next(passo);
  }

  atualizaNomeProcesso(nome: string) {
    this.nomeProcesso.next(nome);
  }

}



// WEBPACK FOOTER //
// ./src/app/_shared/barra-progresso/barra-progresso.service.ts